import { Dispatch } from 'redux';

import {
  CONTRACTS_LOAD_REQUEST,
  CONTRACTS_LOAD_SUCCESS,
  CONTRACTS_LOAD_FAILURE,
  CONTRACTS_ADD_CONTRACT,
  CONTRACTS_REMOVE_CANDIDATE_PARTY,
  CONTRACTS_REMOVE_CONTRACT
} from '../types/contracts-types';

import {
  CONTRACT_LOAD_REQUEST,
  CONTRACT_LOAD_SUCCESS,
  CONTRACT_LOAD_FAILURE
} from '../types/contract-types';
import { ContractUsecaseImpl } from '../../../domain/usecases/contract-usecases';
import { ContractRepositoryImpl } from '../../../data/repositories/contract-repository-impl';
import { ClientRepositoryImpl } from '../../../../clients/data/repositories/client-repository-impl';
import { ClientUsecaseImpl } from '../../../../clients/domain/usecases/client-usecase';

export const createContractAction = (promisor_id: string, promisee_id: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: CONTRACT_LOAD_REQUEST });

    try {
      const contractRepository = new ContractRepositoryImpl();
      const contractUsecase = new ContractUsecaseImpl(contractRepository);

      const result = await contractUsecase.CreateContract(promisor_id, promisee_id);

      dispatch({ type: CONTRACT_LOAD_SUCCESS, payload: result });
      dispatch({ type: CONTRACTS_ADD_CONTRACT, payload: result });
      dispatch({ type: CONTRACTS_REMOVE_CANDIDATE_PARTY, payload: result });
    } catch (error) {
      dispatch({ type: CONTRACT_LOAD_FAILURE, error });
    }
  };
};

export const getContractsAction = (client_id: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: CONTRACTS_LOAD_REQUEST });

    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const clients = await clientUsecase.GetClients();

      const contractRepository = new ContractRepositoryImpl();
      const contractUsecase = new ContractUsecaseImpl(contractRepository);

      const contracts = await contractUsecase.GetContracts(client_id);

      const candidate_parties = clients.filter(
        ({ id: id1 }) => !contracts.some(({ promisee: id2 }) => id2.id === id1)
      );

      dispatch({ type: CONTRACTS_LOAD_SUCCESS, payload: { contracts, candidate_parties } });
    } catch (error) {
      dispatch({ type: CONTRACTS_LOAD_FAILURE, error });
    }
  };
};

export const deleteContractAction = (contract_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    // dispatch({ type: LOADING_REQUEST });

    try {
      const contractRepository = new ContractRepositoryImpl();
      const contractUsecase = new ContractUsecaseImpl(contractRepository);

      const result = await contractUsecase.DeleteContract(contract_id);

      // dispatch({ type: CONTRACT_LOAD_SUCCESS, payload: result });
      dispatch({ type: CONTRACTS_REMOVE_CONTRACT, payload: result });
      // dispatch({ type: CONTRACTS_REMOVE_CANDIDATE_PARTY, payload: result });
      props.closeBackdrop();
      props.showSnackbar();
    } catch (error) {
      // dispatch({ type: LOADING_FAILURE, error });
      props.closeBackdrop();
      props.showSnackbar('error', error);
    }
  };
};
